/* ------------------------ Contact form + reCAPTCHA ------------------------ */
function initContactForm() {
	const contactPage = document.querySelector('#contact');
	const contactForm = document.querySelector('#contactForm');
	if (!(contactPage && contactForm)) return;

	// Refresh reCAPTCHA token every 90s (if available)
	if (window.grecaptcha) {
		setInterval(() => {
			grecaptcha.ready(function () {
				grecaptcha.execute('6LfpwfgrAAAAAAnjKk9KNAFx4QSAz9TaFP7fNhzQ', { action: 'submit' }).then(function (token) {
					let tokenField = contactForm.querySelector('input[name="g-recaptcha-response"]');
					if (!tokenField) {
						tokenField = document.createElement('input');
						tokenField.type = 'hidden';
						tokenField.name = 'g-recaptcha-response';
						contactForm.appendChild(tokenField);
					}
					tokenField.value = token;
				});
			});
		}, 90000);
	}

	contactForm.addEventListener('submit', function (event) {
		event.preventDefault();

		const spamField = document.querySelector('input#Form_Email');
		if (spamField && spamField.value) return false;

		const loadingSpinner = document.querySelector('.section-form .loading');
		if (loadingSpinner) loadingSpinner.classList.add('mod-show');

		// Need grecaptcha + jQuery
		if (!window.grecaptcha || !(window.$ && $.ajax)) {
			if (loadingSpinner) loadingSpinner.classList.remove('mod-show');
			return;
		}

		// Build URL; if a hidden CSRF field exists, append as query (?csrf=...)
		let url = 'process/contact/';
		const csrfField = contactForm.querySelector('input[name="csrf"]');
		if (csrfField && csrfField.value) {
			url += (url.includes('?') ? '&' : '?') + 'csrf=' + encodeURIComponent(csrfField.value);
		}

		// Helper: reset errors UI
		const clearErrorsUI = () => {
			document.querySelectorAll('#contactForm .sub-error').forEach((el) => { el.innerHTML = ''; });
			document.querySelectorAll('#contactForm .form-element').forEach((el) => { el.classList.remove('mod-error'); });
			const formMsg = contactForm.firstElementChild && contactForm.firstElementChild.nextElementSibling;
			if (formMsg) formMsg.innerHTML = '';
		};

		// Helper: render errors from server (works with { field: {message} } or {errors:{...}})
		const renderErrors = (payload) => {
			const errors = payload?.errors && typeof payload.errors === 'object' ? payload.errors : payload;
			if (!errors || typeof errors !== 'object') return;

			const formMsg = contactForm.firstElementChild && contactForm.firstElementChild.nextElementSibling;
			if (formMsg) formMsg.innerHTML = 'Please fix the errors below:';

			for (const [key, value] of Object.entries(errors)) {
				if (!key) continue;
				const msg = (value && typeof value === 'object') ? value.message : value;
				const errorEl = document.querySelector('#contactForm .sub-error[data-error="' + key + '"]');
				if (errorEl) errorEl.innerHTML = msg || 'There is an error with this field.';
				if (key !== 'recaptcha') {
					const formEl = document.querySelector('#contactForm .form-element.mod-' + key);
					if (formEl) formEl.classList.add('mod-error');
				}
			}
		};

		grecaptcha.ready(function () {
			grecaptcha.execute('6LfpwfgrAAAAAAnjKk9KNAFx4QSAz9TaFP7fNhzQ', { action: 'submit' }).then(function (token) {
				let tokenField = contactForm.querySelector('input[name="g-recaptcha-response"]');
				if (!tokenField) {
					tokenField = document.createElement('input');
					tokenField.type = 'hidden';
					tokenField.name = 'g-recaptcha-response';
					contactForm.appendChild(tokenField);
				}
				tokenField.value = token;

				clearErrorsUI();

				$.ajax({
					method: 'POST',
					url,
					dataType: 'json',
					data: $(contactForm).serialize()
				})
				.done(function (response) {
					// Success may be "success" (string) or {status:'success'}
					const ok = (response === 'success') || (response && response.status === 'success') || (response && response.ok === true);
					if (!ok) {
						// If server returned 200 with errors object (unlikely now), show them
						renderErrors(response);
						if (loadingSpinner) loadingSpinner.classList.remove('mod-show');
						return;
					}

					if (loadingSpinner) loadingSpinner.classList.remove('mod-show');

					// Clear filled states
					document.querySelectorAll('#contactForm .form-element').forEach((el) => {
						el.classList.remove('mod-filled');
					});

					console.log(contactForm);
					

					// Success UI
					contactForm.classList.add('mod-hide');
					if (contactForm.nextElementSibling) contactForm.nextElementSibling.classList.add('mod-show');
					const formMsg = contactForm.firstElementChild && contactForm.firstElementChild.nextElementSibling;
					if (formMsg) formMsg.innerHTML = '';

					// Reset fields/errors
					document.querySelectorAll('#contactForm .form-element input, #contactForm .form-element textarea').forEach((el) => { el.value = ''; });
					clearErrorsUI();

					setTimeout(function () {
						contactForm.classList.remove('mod-hide');
						if (contactForm.nextElementSibling) contactForm.nextElementSibling.classList.remove('mod-show');
					}, 10000);
				})
				.fail(function (xhr) {
					if (loadingSpinner) loadingSpinner.classList.remove('mod-show');
					// 422 validation errors land here
					let payload = null;
					if (xhr.responseJSON) {
						payload = xhr.responseJSON;
					} else if (xhr.responseText) {
						try { payload = JSON.parse(xhr.responseText); } catch (e) {}
					}

					// If backend returns raw errors object, render it; if it wraps {errors:{...}}, also handled.
					renderErrors(payload || {});
				});
			});
		});
	});
}

/* ------------------------ FAQ accordion ------------------------ */
function initFaqAccordion() {
	const items = document.querySelectorAll('[data-faq-item]');

	items.forEach((item) => {
		const header = item.querySelector('[data-faq-header]');
		const body = item.querySelector('[data-faq-body]');
		const chevron = item.querySelector('[data-faq-chevron]');

		if (!(header && body && chevron)) return;

		header.addEventListener('click', () => {
			const isOpen = body.getAttribute('data-open') === 'true';

			// Close all others
			items.forEach((other) => {
				const otherBody = other.querySelector('[data-faq-body]');
				const otherChevron = other.querySelector('[data-faq-chevron]');
				if (otherBody) otherBody.setAttribute('data-open', 'false');
				if (otherChevron) otherChevron.setAttribute('data-open', 'false');
			});

			// Toggle current
			if (!isOpen) {
				body.setAttribute('data-open', 'true');
				chevron.setAttribute('data-open', 'true');
			}
		});
	});
}

document.addEventListener('DOMContentLoaded', () => {
	const body = document.querySelector('body');

	initContactForm();
	initFaqAccordion();

	// Helper function
	let domReady = (cb) => {
		document.readyState === 'interactive' || document.readyState === 'complete'
			? cb()
			: document.addEventListener('DOMContentLoaded', cb);
	};

	domReady(() => {
		// Display body when DOM is loaded
		body.style.visibility = 'visible';
	});

	// hide cookie policy
	document.querySelector('.section-cookies .btn-accept').addEventListener('click', (e) => {
		e.preventDefault();

		// If no validation errors
		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 1,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	document.querySelector('.section-cookies .btn-decline').addEventListener('click', (e) => {
		e.preventDefault();

		$.ajax({
			method: "POST",
			url: "api/cookies/",
			data: {
				'cookies-accepted': 0,
			}
		}).done(function () {
			$('.section-cookies').addClass('mod-hide').removeClass('show');
		});
	});

	// Hamburger menu function
	document.querySelectorAll('.mob-hamburger').forEach((hamburger) => {
		hamburger.addEventListener('click', (e) => {
			e.preventDefault();

			// Add active class to hamburger so it can be animated
			hamburger.classList.toggle('mod-active');

			hamburger.setAttribute('aria-label', 'Close menu');

			// Add active class to nav to show
			document.querySelector('#nav').classList.toggle('mod-show');

			// Add no scroll class to body to prevent scrolling when nav is active
			body.classList.toggle('no-scroll');

			// Add active class to header
			document.querySelector('.header-main').classList.toggle('mod-active');

			// Add active class on all li's
			if (!hamburger.classList.contains('mod-active')) {
				hamburger.setAttribute('aria-label', 'Open menu');

				document.querySelectorAll('#nav ul li').forEach((element) => {
					element.classList.remove('mod-show');
				});

				setTimeout(function () {
					document.querySelector('#nav').classList.remove('mod-show');
				}, 550);
			} else {
				setTimeout(function () {
					document.querySelectorAll('#nav ul li').forEach((element) => {
						element.classList.add('mod-show');
					});
				}, 900);
			}
		});
	});

	// Add class to inputs when clicked on add effect
	const form = document.querySelectorAll('form');

	if (form) {
		document.querySelectorAll('form input, form textarea').forEach((element) => {
			element.addEventListener('focus', () => {
				element.parentElement.classList.add('mod-filled');
			});

			element.addEventListener('blur', () => {
				if (element.value) {
					element.parentElement.classList.add('mod-filled');
				} else {
					element.parentElement.classList.remove('mod-filled');
				}
			});
		});
	}

	const jsSlick = document.querySelector('.js-slick.js-hero');

	if (jsSlick && jsSlick.children.length > 0) {
		$(jsSlick).slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: true,
			fade: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 750
		});
	}

	const testimonials = document.querySelector('.testimonials.js-slick');

	if (testimonials && testimonials.children.length > 0) {
		$(testimonials).slick({
			arrows: false,
			autoplay: true,
			autoplaySpeed: 7500,
			dots: true,
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
			speed: 750
		});
	}

	// Scroll to Google reviews section on home, navigating there first if needed
	const googleReviewsLink = document.querySelector('.js-google-reviews-link');

	if (googleReviewsLink) {
		const googleReviewsSection = document.querySelector('#google-reviews');

		googleReviewsLink.addEventListener('click', (e) => {
			if (googleReviewsSection) {
				e.preventDefault();
				googleReviewsSection.scrollIntoView({ behavior: 'smooth' });
			} else {
				sessionStorage.setItem('scrollToGoogleReviews', '1');
			}
		});

		if (googleReviewsSection && sessionStorage.getItem('scrollToGoogleReviews')) {
			sessionStorage.removeItem('scrollToGoogleReviews');
			googleReviewsSection.scrollIntoView({ behavior: 'smooth' });
		}
	}

	const bttLink = document.querySelector('.btt');

	if (bttLink) {
		bttLink.addEventListener('click', function (e) {
			e.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		});
	}
});